import styled from 'styled-components'

const TableStyle = styled.div`
    padding: 1rem;
    table {
        border-spacing: 0;
        border: 1px solid black;
        tr,
        th,
        td {
            margin: 0;
            padding: 0.5rem;
            border: 0;
        }
    }
`

const CropAreaTableStyle = styled.div`
    padding: 1rem;
    table {
        width: auto;
        border-spacing: 0;
        border: 1px solid black;
        tr,
        th,
        td {
            margin: 0;
            padding: 0.5rem;
            border: 0;
        }
    }
    th {
        textAlign: left;
    }
`

const ColumnsCurrent = [
    {
        Header: 'Control Measures Selected',
        accessor: 'measures',
        backgroundColor: '#a7c81e',
        width: 200,
        borderRight: '3px solid black'
    },
    {
        Header: 'Notes/Reasons for Selection',
        accessor: 'notes',
        backgroundColor: '#a7c81e',
        width: 200,
    },
    {
        Header: 'Efficacy of Previous Use',
        accessor: 'efficacyOfPreviousUse',
        backgroundColor: '#a7c81e',
        width: 200,
    },
    {
        Header: 'Level of risk identified for pest targeted by selected control measure',
        columns: [
            {
                Header: 'Significant Risk',
                accessor: 'significantRisk',
                backgroundColor: '#0da4a3',
                width: 200,
            },
            {
                Header: 'Moderate Risk',
                accessor: 'moderateRisk',
                backgroundColor: '#0da4a3',
                width: 200,
            },
            {
                Header: 'Slight Risk',
                accessor: 'slightRisk',
                backgroundColor: '#0da4a3',
                width: 200,
            },
        ],
    },
];

const ColumnsFuture = [
    {
        Header: 'Control Measures Selected',
        accessor: 'measures',
        backgroundColor: '#a7c81e',
        width: 200,
        borderRight: '3px solid black'
    },
    {
        Header: 'Notes/Reasons for Selection',
        accessor: 'notes',
        backgroundColor: '#a7c81e',
        width: 200,
    },
    {
        Header: 'Level of risk identified for pest targeted by selected control measure',
        columns: [
            {
                Header: 'Significant Risk',
                accessor: 'significantRisk',
                backgroundColor: '#0da4a3',
                width: 200,
            },
            {
                Header: 'Moderate Risk',
                accessor: 'moderateRisk',
                backgroundColor: '#0da4a3',
                width: 200,
            },
            {
                Header: 'Slight Risk',
                accessor: 'slightRisk',
                backgroundColor: '#0da4a3',
                width: 200,
            },
        ],
    },
];

const ColumnsNotSelected = [
    {
        Header: '',
        accessor: 'measures',
        width: 200,
        borderRight: '3px solid black'
    },
    {
        Header: 'Notes/Reasons for Selection',
        accessor: 'notes',
        width: 200,
    },
    {
        Header: 'Level of risk identified for pest targeted by selected control measure',
        columns: [
            {
                Header: 'Significant Risk',
                accessor: 'significantRisk',
                backgroundColor: '#0da4a3',
                width: 200,
            },
            {
                Header: 'Moderate Risk',
                accessor: 'moderateRisk',
                backgroundColor: '#0da4a3',
                width: 200,
            },
            {
                Header: 'Slight Risk',
                accessor: 'slightRisk',
                backgroundColor: '#0da4a3',
                width: 200,
            },
        ],
    },
];

const ColumnsCropArea = [
    {
        Header: 'Crop',
        accessor: 'cropTitle'
    },
    {
        Header: 'Area (ha)',
        accessor: 'area'
    }
]

export { TableStyle, CropAreaTableStyle, ColumnsCurrent, ColumnsFuture, ColumnsNotSelected, ColumnsCropArea };